
export class FormDocBuilder {
  header: FormHeader;
  footer: FormFooter;
  blocks: FormBlock[];
}
export class FormHeader {
  title: string;
  imageUrl: string;
  show: boolean;
  titleAlignment: string;
  pictureAlignment: string;
  headerText:string;
  headerTextAligment:string;
}
export class FormFooter {
  imageUrl: string;
  show: boolean;
  pictureAlignment: string;
  footerText:string;
  footerTextAligment:string;
}

export class FormBlock {
  blockId: string;
  sectionTitle: string;
  items: any[];
}

export class BlockItemBase {
  itemId: string;
  type: number;
  value: string;
}

export class SignatureBlockItem extends BlockItemBase {
  role: string;
  withDate: boolean;
}

export class ParagraphBlockItem extends BlockItemBase {
  text: string;
}

export class MultipleOptionsInputBlockItemBase extends BlockItemBase {
  options: string[];
  question: string;
  selectionOption: number;
}

export class SimpleInputBlockItemBase extends BlockItemBase {
  html5InputType: string;
  label: string;
}

export class PatientInfoBlockItem extends SimpleInputBlockItemBase {
  patientInfo: string;
}

export class PatientMultipleInfoBlockItem extends SimpleInputBlockItemBase {
  patientInfo: string;
  patientDataValues: string[];
}

export class PatientInfoOption {
  patientInfo: string;
  friendlyName: string;
  itemType: number;
}
